export const getImage = img => {
  if (img.includes('http')) {
    return img;
  }
  // eslint-disable-next-line
  return require(`../assets/images/${img}`);
};
